import { Injectable, Inject, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { Observable ,  Subject ,  BehaviorSubject } from 'rxjs';



import { Config } from '../config/env.config';
import { AuthService } from '../auth/auth.service';

import * as _ from 'lodash';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';

@Injectable()
export class BrandService {

    private brand: any;

    private _initBrandChoose: BehaviorSubject<boolean>;
    private selectedBrand = new Subject<any>();

    constructor(
      private http: HttpClient,
      @Inject(AuthService) private authService: AuthService
    ) {
      this._initBrandChoose = <BehaviorSubject<boolean>>new BehaviorSubject(false);
    }

    // getters
    get brandChoose() {
      return this._initBrandChoose.asObservable();
    }

    get brandChange() {
      return this.selectedBrand.asObservable();
    }

    // Service message commands
    changeSelectedBrand(brand: any) {
      this.storeBrand(brand);
      this.selectedBrand.next(brand);
    }

    getBrands(): Observable<any> {
      return this.http.get(Config.API + '/auth-brands')
        .pipe(map((res: any) => res.data),
        catchError(this.handleError.bind(this)));
    }

    getBrandList(): Observable<any> {
      return this.http.get(Config.API + '/auth-brands/list')
        .pipe(catchError(this.handleError.bind(this)));
    }

    storeBrand(brand: any): void {
      this.brand = brand;
      localStorage.setItem('selected_full_brand', JSON.stringify(brand));
    }

    removeStoredBrand(): void {
      this.brand = null;
      localStorage.removeItem('selected_full_brand');
    }

    getBrand(): string {
      const brand = this.getStoredBrand();
      return _.get(brand, 'id', null);
    }

    getStoredBrand(): any {
      if (_.has(this.brand, 'id')) {
        return this.brand;
      } else {
        const brand = JSON.parse(localStorage.getItem('selected_full_brand'));
        this.brand = brand;
        return brand;
      }
    }

    initBrandChoose() {
      this._initBrandChoose.next(true);
    }

    protected handleError(err: any) {
      let errMessage: string;

      if (err instanceof HttpErrorResponse) {
          const body = err.error || '';
          const error = body.error || JSON.stringify(body);

          if (error === 'token_invalid' || error === 'user_not_found' || err.status === 401) {
              this.authService.logout();
          }

          errMessage = `${err.status} - ${err.statusText} || ''} ${error}`;
      } else {
          errMessage = err.message ? err.message : err.toString();
          if (errMessage === 'No JWT present or has expired') {
            this.authService.logout();
          }
      }

      return of(errMessage);
    }
}
